module.exports = __webpack_public_path__ + "static/media/user.e65f4f36.png";